export default {
    baseStyle: {
        container: {
            w: {base: '100%'},
            my: {base: 6, md: 8},
            px: {base: 4, md: 0},
            maxW: {md: '458px'},
            ml: {md: 'auto'},
            mr: {md: 'auto'}
        },
        fields: {
            gap: 3
        },
        submitButton: {
            maxW: {md: '225px'},
            mt: {base: 9}
        }
    }
}
